// extracted by mini-css-extract-plugin
export var socialLink = "socialLinks-module--socialLink--nd9OQ";
export var socialLinks = "socialLinks-module--socialLinks--CpzG1";